export interface Webhook {
  bearerToken: string;
  id: string | symbol;
  name: string;
  url: string;
  topic: string;
  kind: string;
  status?: WebhookStatus;
}

export enum WebhookStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export interface Client {
  id: string | symbol;
  name: string;
  bearerToken: string;
  teams: string[];
}

export interface DeveloperValue {
  webhooks: Webhook[];
  apiClients: Client[];
}

export interface WebhookValue {
  bearerToken: string;
  name: string;
  url: string;
  topic: string;
  kind: string;
}

export interface ClientValue {
  name: string;
  bearerToken: string;
  teams: string[];
}
